import { withNfe } from "@moodys/federated";

import { SplitFactoryLayoutContext } from "../SplitFactoryLayoutContext/SplitFactoryLayoutContext";

import { Footer } from "./Footer";

export const FooterWithLayoutProvider = () => {
  return (
    <SplitFactoryLayoutContext>
      <Footer />
    </SplitFactoryLayoutContext>
  );
};

export default withNfe(FooterWithLayoutProvider);
